import { ModalProps, Modal as Wrapped } from "antd"
import { FC, useRef, useState } from "react"

import { ModalMode, useGeneralContext } from "../context/GeneralContext"
import { SvgIcon } from "../icon"

type ModalCustomProps = {
  topOffset?: number | null
  mode?: ModalMode
  isFullScreen?: boolean
}

const Modal: FC<ModalCustomProps & ModalProps> = ({
  topOffset = 100,
  mode = "default",
  isFullScreen = false,
  ...baseProps
}) => {
  const {
    setIsModalOpen,
    setModalWidth,
    setApprovalLetterInfo,
    setEmailBodyDocument,
    setExpiryDate,
    setMode,
    setCurrentProject,
    modalWidth,
    setModalMode,
    modalMode,
  } = useGeneralContext()

  const previousWidth = useRef<number | string | null>(null)

  const onToggleFullscreen = () => {
    if (modalWidth === "100vw") {
      setModalWidth(previousWidth.current)
      setModalMode("default")
    } else {
      previousWidth.current = modalWidth
      setModalWidth("100vw")
      setModalMode("fullscreen")
    }
  }

  const [isOpen, setIsOpen] = useState(false)
  const onCancel = () => {
    setIsOpen(false)
    setIsModalOpen(false)
    setModalWidth(null)
    setApprovalLetterInfo(null) // Needed for approval form
    setEmailBodyDocument(null) // As above: the email PDF must not reach the next approval form opened
    setExpiryDate(null) // Needed for approval form
    setMode(null) // Needed for Company Info update request processing modal
    setCurrentProject(null)
    setModalMode("default")
  }

  return (
    <Wrapped
      open={isOpen}
      closable={true}
      footer={false}
      className={`main-modal ${mode === "fullscreen" ? "fullscreen-modal" : ""}`}
      closeIcon={
        isFullScreen ? (
          <div className={"modal-icons"}>
            <span
              className={"modal-resize-icon"}
              onClick={e => {
                e.stopPropagation()
                onToggleFullscreen()
              }}
            >
              <SvgIcon type={modalWidth === "100vw" ? "collapse-mode" : "expand-mode"} color={"gray"} />
            </span>

            <SvgIcon type={"close-modal"} />
          </div>
        ) : (
          <SvgIcon type={"close-modal"} />
        )
      }
      onCancel={onCancel}
      destroyOnClose={true}
      style={{
        top: mode === "fullscreen" ? 0 : topOffset ?? 100,
      }}
      {...baseProps}
    />
  )
}

export { Modal }
